
<template>
    <div>
        <div class="upgrade-form py-4 px-5">
            <h3 class="text-center mb-4">Enter Payment</h3>
            <div class="ad-on-payment-wrapper pt-4">
                <b-row>
                    <b-col>
                        <h2 class="plan-type-title">Plan</h2>
                        <span class="py-2 px-3 mb-3 d-inline-block plan-type-professional">
                            Professional
                        </span>
                        <h3 class="mb-3">Credit Card or Debit Card</h3>
                        <div>
                            <b-row no-gutters>
                                <b-col class="pr-1">
                                    <b-form-group
                                        id="credit-card-number-fieldset"
                                    >
                                        <b-form-input id="credit-card-number" placeholder="Enter Card Number"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="2" class="px-1">
                                    <b-form-group
                                        id="mm-fieldset"
                                    >
                                        <b-form-select v-model="selectedMM" :options="mmOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="2" class="px-1">
                                    <b-form-group
                                        id="yy-fieldset"
                                    >
                                        <b-form-select v-model="selectedYY" :options="yyOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="2" class="pl-1">
                                    <b-form-group
                                        id="cvv-fieldset"
                                    >
                                        <b-form-input id="cvv" placeholder="CVV" type="number"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="billing-address-line-1-fieldset"
                                    >
                                        <b-form-input id="billing-address-line-1" placeholder="Billing Address Line 1"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="billing-address-line-2-fieldset"
                                    >
                                        <b-form-input id="billing-address-line-2" placeholder="Billing Address Line 2 (Optional)"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        id="country-fieldset"
                                    >
                                        <b-form-select v-model="selectedCountry" :options="countryOptions"></b-form-select>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row no-gutters>
                                <b-col class="pr-1">
                                    <b-form-group
                                        id="city-fieldset"
                                    >
                                        <b-form-input id="city" placeholder="City"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col class="pl-1">
                                    <b-form-group
                                        id="zip-code-fieldset"
                                    >
                                        <b-form-input id="zip-code" placeholder="Zip Code"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col>
                        <div class="payment-wrapper py-4 px-3">
                            <h4 class="text-center mt-0 mb-3">Bill Summary</h4>
                            <div>
                            <b-tabs pills>
                                <b-tab title="Monthly" active>
                                    <div class="pt-3 px-4">
                                        <b-row>
                                            <b-col>
                                                <h5 class="plan-type-title">Plan Upgrade</h5>
                                                <span class="py-2 px-3 d-inline-block plan-type-professional">
                                                    Professional
                                                </span>
                                            </b-col>
                                            <b-col><p class="price text-right">Php 14,999</p></b-col>
                                        </b-row>
                                        <h5 class="ad-ons-heading mt-4 mb-3">
                                            Ad On's
                                        </h5>
                                        <b-row>
                                            <b-col>
                                                <p class="ad-ons-title">Restaurant Reservation</p>
                                            </b-col>
                                            <b-col><p class="price text-right">Php 5,000</p></b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>E-Store</b-col>
                                            <b-col><p class="price text-right">Php 5,000</p></b-col>
                                        </b-row>
                                        <div class="total-wrapper pt-3 mt-2">
                                            <b-row>
                                                <b-col>
                                                    <p class="total-heading">Total per year</p>
                                                    <p class="total">Php 24,999</p>
                                                </b-col>
                                            </b-row>
                                            <b-row class="pt-2">
                                                <b-col>
                                                    <p class="total-savings-heading">Total savings with yearly plan:</p>
                                                    <p class="total-savings">Php 3,000</p>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col class="pt-2">
                                                    <b-form>
                                                        <b-form-group id="promo-code-group" label-for="promo-code">
                                                            <b-form-input
                                                                id="promo-code"
                                                                required
                                                                placeholder="Promo Code"
                                                            ></b-form-input>
                                                        </b-form-group>
                                                    </b-form>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </div>
                                </b-tab>
                                <b-tab title="Quarterly">
                                    <div class="pt-3 px-4">
                                        <b-row>
                                            <b-col>
                                                <h5 class="plan-type-title">Plan Upgrade</h5>
                                                <span class="py-2 px-3 d-inline-block plan-type-professional">
                                                    Professional
                                                </span>
                                            </b-col>
                                            <b-col><p class="price text-right">Php 14,999</p></b-col>
                                        </b-row>
                                        <h5 class="ad-ons-heading mt-4 mb-3">
                                            Ad On's
                                        </h5>
                                        <b-row>
                                            <b-col>
                                                <p class="ad-ons-title">Restaurant Reservation</p>
                                            </b-col>
                                            <b-col><p class="price text-right">Php 5,000</p></b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>E-Store</b-col>
                                            <b-col><p class="price text-right">Php 5,000</p></b-col>
                                        </b-row>
                                        <div class="total-wrapper pt-3 mt-2">
                                            <b-row>
                                                <b-col>
                                                    <p class="total-heading">Total per year</p>
                                                    <p class="total">Php 24,999</p>
                                                </b-col>
                                            </b-row>
                                            <b-row class="pt-2">
                                                <b-col>
                                                    <p class="total-savings-heading">Total savings with yearly plan:</p>
                                                    <p class="total-savings">Php 3,000</p>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col class="pt-2">
                                                    <b-form>
                                                        <b-form-group id="promo-code-group" label-for="promo-code">
                                                            <b-form-input
                                                                id="promo-code"
                                                                required
                                                                placeholder="Promo Code"
                                                            ></b-form-input>
                                                        </b-form-group>
                                                    </b-form>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </div>
                                </b-tab>
                                <b-tab title="Yearly">
                                    <div class="pt-3 px-4">
                                        <b-row>
                                            <b-col>
                                                <h5 class="plan-type-title">Plan Upgrade</h5>
                                                <span class="py-2 px-3 d-inline-block plan-type-professional">
                                                    Professional
                                                </span>
                                            </b-col>
                                            <b-col><p class="price text-right">Php 14,999</p></b-col>
                                        </b-row>
                                        <h5 class="ad-ons-heading mt-4 mb-3">
                                            Ad On's
                                        </h5>
                                        <b-row>
                                            <b-col>
                                                <p class="ad-ons-title">Restaurant Reservation</p>
                                            </b-col>
                                            <b-col><p class="price text-right">Php 5,000</p></b-col>
                                        </b-row>
                                        <b-row>
                                            <b-col>E-Store</b-col>
                                            <b-col><p class="price text-right">Php 5,000</p></b-col>
                                        </b-row>
                                        <div class="total-wrapper pt-3 mt-2">
                                            <b-row>
                                                <b-col>
                                                    <p class="total-heading">Total per year</p>
                                                    <p class="total">Php 24,999</p>
                                                </b-col>
                                            </b-row>
                                            <b-row class="pt-2">
                                                <b-col>
                                                    <p class="total-savings-heading">Total savings with yearly plan:</p>
                                                    <p class="total-savings">Php 3,000</p>
                                                </b-col>
                                            </b-row>
                                            <b-row>
                                                <b-col class="pt-2">
                                                    <b-form>
                                                        <b-form-group id="promo-code-group" label-for="promo-code">
                                                            <b-form-input
                                                                id="promo-code"
                                                                required
                                                                placeholder="Promo Code"
                                                            ></b-form-input>
                                                        </b-form-group>
                                                    </b-form>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </div>
                                </b-tab>
                            </b-tabs>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="button-wrapper px-5 py-3" v-bind:class="{ 'retain-height': subIsActive('/upgrade/start') }">
            <b-button variant="outline-secondary" v-show="!subIsActive('/upgrade/start')" :to="'/upgrade/step-2'">
                Back
            </b-button>
            <b-button variant="primary" class="float-right" :to="'/upgrade/success'">
                Finish Payment
            </b-button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: 'step-2',
    data() {
        return {
            selectedMM: null,
            selectedYY: null,
            mmOptions: [
                { value: null, text: 'MM' },
                { value: null, text: '01' },
                { value: null, text: '02' },
                { value: null, text: '03' },
                { value: null, text: '04' },
                { value: null, text: '05' },
                { value: null, text: '06' },
                { value: null, text: '07' },
                { value: null, text: '08' },
                { value: null, text: '09' },
                { value: null, text: '10' },
                { value: null, text: '11' },
                { value: null, text: '12' },
            ],
            yyOptions: [
                { value: null, text: 'YY' },
                { value: null, text: '20' },
                { value: null, text: '21' },
                { value: null, text: '22' },
                { value: null, text: '23' },
                { value: null, text: '24' },
                { value: null, text: '25' },
                { value: null, text: '26' },
                { value: null, text: '27' },
                { value: null, text: '28' },
                { value: null, text: '29' },
                { value: null, text: '30' },
                { value: null, text: '31' },
                { value: null, text: '32' },
            ],
            selectedCountry: 'PH',
            countryOptions: [
                { value: 'PH', text: 'Philippines' }
            ],
        }
    },
    methods: {
        subIsActive(input) {
            const paths = Array.isArray(input) ? input : [input];
            return paths.some(path => {
                return this.$route.path.indexOf(path) === 0; // current path starts with this path string
            });
        }
    }
};
</script>
<style lang="scss">
</style>